/* eslint react/no-danger: 0 */
import React, { useEffect, useRef, useState } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import PillarScrollers from '../Home/PillarScrollers';
import SecondaryNav from '../SecondaryNav';
import Play from './Play/Play';
import Audio from './Audio/Audio';
//import content from '../../content';
import { GAfireEvent } from '../Tracking';
import { isEs } from "../../libs/lang";

import videoSquare from "../../video/en-hero-mobile.mp4";
import videoSquareES from "../../video/hero-video-square-es.mp4";

import videoTablet from "../../video/en-hero-desktop.mp4";
import videoTabletES from "../../video/hero-video-16x9-es.mp4";

import videoPlaceholder from "../../images/masthead/hero-video-desktop.jpg";
import videoPlaceholderTablet from "../../images/masthead/hero-video-tablet.jpg";
import videoPlaceholderES from "../../images/masthead/hero-video-desktop-es.png";
import videoPlaceholderTabletES from "../../images/masthead/hero-video-tablet-es.png";




import {fireTag} from '../../libs/analytics';

/* eslint-disable global-require */
let content = {};

if (isEs()) {
	content = require('../../contentES').default;
}
else {
	content = require('../../content').default;
}

const Masthead = (props) => {
	const mastheadRef = useRef(null);
	const [isPlaying, setIsPlaying] = useState(true);
	const [audioOn, setAudioOn] = useState(false);
	const [videoHeight, setVideoHeight] = useState(0);
	const playerRef = useRef(null);

	const [transcriptOpen, setTranscriptOpen] = useState(false);

	const h1 = isEs() ?
		`<span class='gold es'>Haciendo,</span> se construyen realidades` : `<span class='gold'>Doing</span> Gets It Done`;

	const navPrimaryHeights = window.innerWidth < 570 ? 42 : 60;
	const navSecondaryHeight = window.innerWidth < 768 ? 0 : 40;

	const videoSrc = window.innerWidth < 1080 && window.innerWidth > 570 ? isEs() ? videoTabletES : videoTablet : isEs() ? videoSquareES : videoSquare;
	const videoPoster = window.innerWidth < 1080 && window.innerWidth > 570 ? isEs() ? videoPlaceholderTabletES : videoPlaceholderTablet : isEs() ? videoPlaceholderES : videoPlaceholder;

	const isIOS = () => {
		const userAgent = window.navigator.userAgent.toLowerCase();
		return (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1);
	}

	const isMobileDevice = () => {
		const userAgent = window.navigator.userAgent.toLowerCase();
		console.log(userAgent)
		return (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1 || userAgent.indexOf('android') > -1);
	}
	const isMobileUI = (breakpoint = 768) => window.innerWidth < breakpoint;
	const redNavHeight = window.innerWidth < 570 ? 42 : 60;


	const pillarAnchorClick = (evt, pillarTab) => {
		evt.preventDefault();

		const tabLabel = evt.currentTarget.children[1].innerText.toLowerCase();
		//GAfireEvent("home_C1", {label: tabLabel});

		const pillarTabs = document.querySelectorAll('a.tab');

		//How far the user has already scrolled to get to the anchor link
		const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

		const scrollVal = pillarTabs[pillarTab].getBoundingClientRect().top - redNavHeight - 1 + scrollTop;
		document.documentElement.scrollTo({top: scrollVal, left: 0, behavior: 'smooth'});
		window.setTimeout(() => {
			pillarTabs[pillarTab].focus();
		}, 1000);
	}

	const PillarAnchor = ({item, index}) => (
		<a
			className={`anchor-item ${isEs ? 'es' : ''} item_${index}`}
			href={`#tab-${index}`}
			onClick={e => {pillarAnchorClick(e, index); fireTag(`C${index + 1}`)}}
			onFocus={e => document.documentElement.scrollTo({top: 0, left: 0, behavior: 'smooth'})}
			data-tab-num={index}
		>
			<span className='tab-icon'><img src={`${process.env.PUBLIC_URL}${item.icon.src}`} alt={''}/></span>
			<span className='tab-text'>{item.tabLabel}</span>
		</a>
	)

	useEffect(() => {

		smoothscroll.polyfill();

		console.log(playerRef.current.clientHeight);

		// Waits until fully loaded to set video player height
		playerRef.current.addEventListener("loadedmetadata", (event) => {
			setVideoHeight(playerRef.current.clientHeight + 50);
		  });

		const adjustMastheadScrollBehavior = () => {
			if (mastheadRef.current) {
				console.log('looking at regular scroll', isMobileDevice(), isMobileUI())
				if (window.innerWidth > 767 && window.innerWidth < 1024 && window.innerHeight < 615) {
					mastheadRef.current.classList.add('regular-scroll');
				}
				else if (window.innerWidth > 1023 && window.innerHeight < 735) {
					mastheadRef.current.classList.add('regular-scroll');
				}
				else if (!isMobileDevice() && isMobileUI()) {
					// desktop zoomed into mobile UI
					mastheadRef.current.classList.add('regular-scroll');
				}
				else if (window.innerWidth < 768 && document.documentElement.clientHeight < 850) {
					// making this just for mobile devices
					mastheadRef.current.classList.add('regular-scroll');
				}
				else {
					mastheadRef.current.classList.remove('regular-scroll');
				}
			}
		}

		// WCAG support - needed so that background video remains visible once mobile ui is shown on desktop
		window.addEventListener('resize', e => {
			if (isMobileUI(768) && !isMobileDevice() && mastheadRef.current) {
				mastheadRef.current.style.height = '100vh';
			}
			adjustMastheadScrollBehavior();

			setVideoHeight(playerRef.current.clientHeight + 50);
		})

		playerRef.current.addEventListener('ended', function() {
			playerRef.current.load();    
			playerRef.current?.pause(); 
			setIsPlaying(false);
		});

		// These are to sync with the players built in controls - Chrome, right-click on video -> 'show all controls'
		playerRef.current.addEventListener('pause', function() {
			setIsPlaying(false);
		});

		playerRef.current.addEventListener('play', function() {
			setIsPlaying(true);
		});

		playerRef.current.addEventListener('volumechange', function(e) {
			if (e.target.muted) {
				setAudioOn(false);
			} else {
				setAudioOn(true);
			}
		});

		// -------------------------------------------------------------

		adjustMastheadScrollBehavior();

		if (mastheadRef.current) {
			if (props.shouldBeInert) {
				mastheadRef.current.setAttribute('inert', '');
			}
			else {
				mastheadRef.current.removeAttribute('inert');
			}
		}
	}, [navPrimaryHeights, navSecondaryHeight, props.shouldBeInert]);

	const bgImg = isEs() ? "Trabajando en una granja, un joven sonríe al abrir una carta de aceptación de la universidad." : "A young man smiles as he opens a college acceptance letter while at work on a farm.";
	let transcriptCTA = isEs() ? 'Ve la transcripción' : 'View Transcript';

	return (
        <>
            <div className="sticky" id="masthead" ref={mastheadRef} style={{ height: window.innerWidth < 1080 ? "" : videoHeight}}>
				{!props.isMobile && <SecondaryNav shouldBeInert={props.shouldBeInert} activePage="home" />}
				<div className={`masthead-text ${isEs() ? 'es' : ''}`}>
					<h1
						id="home-main-h1"
						className={isEs() ? 'es' : ''}
						dangerouslySetInnerHTML={{ __html: h1 }}
						tabIndex="-1"
					/>
					{isEs() ? (
						<>
							<p>
								Somos el banco que pone primero a la gente y las comunidades. El banco que se remanga la
								camisa y se involucra. Somos el banco que hace lo que dice y toma acción.
							</p>
							<p>El banco para ir con todo.</p>
						</>
					) : (
						<>
							<p>
								We're the bank of putting people and communities first. The bank of rolling up our
								sleeves and getting involved. We're the bank of walking the walk and taking action.
							</p>
							<p>That’s the Bank of Doing.</p>
						</>
					)}
					<div className={`pillar-anchors ${isEs() ? 'es' : ''}`}>
						{content.home.pillarCards.map((item, i) => (
							// eslint-disable-next-line react/no-array-index-key
							<PillarAnchor item={item} index={i} key={i} />
						))}
					</div>
				</div>
                <div className="masthead-video">
					<button 
						tabIndex={0}
						id={'masthead-button-transcript'}
						data-transcript={`hero`}
						className={'masthead-button-transcript'}
						onClick={(e)=> {
							fireTag('C12', 'view transcript');
							props.displayModalOverlay(e);
						}}
					>{transcriptCTA}</button>
                    <video
                        ref={playerRef}
                        width={"100%"}
                        controls={false}
						autoPlay={true}
						muted={!audioOn}
                        poster={videoPoster}
                        aria-hidden={true}
                        // onEnded={() => setIsPlaying(false)}
                        // title={videoTitle}
                    >
                        <source src={videoSrc} type="video/mp4" />
                        {/* <track src={videoCaptions[selected]} label="English" kind="captions" srcLang="en-us" default /> */}
                    </video>
					<Play
                  ariaPressed={isPlaying}
                  ariaLabel={''}
                  toggle={isPlaying}
				  tabIndex={0}
                  onClick={() => {
                    if (isPlaying) {
                        // fireGA("C2.2", {innerText: `pause - ${process.env.REACT_APP_LANG === 'spanish' ? JSONContent.titles.spanish[index] : JSONContent.titles.english[index]}`})
						fireTag('C12', 'pause');
						setIsPlaying(false);
						setAudioOn(true);
                        playerRef.current?.pause()
                    } else {
                        // fireGA("C2.2", {innerText: `play - ${process.env.REACT_APP_LANG === 'spanish' ? JSONContent.titles.spanish[index] : JSONContent.titles.english[index]}`})
						fireTag('C12', 'play');
						setIsPlaying(true);
                        playerRef.current?.play()
                    }
                  }}
                />
				<Audio
                  ariaPressed={isPlaying}
                  ariaLabel={''}
                  toggle={audioOn}
				  tabIndex={0}
                  onClick={() => {
                    if (audioOn) {
						fireTag('C12', 'mute');
                        setAudioOn(false);
                    } else {
						fireTag('C12', 'unmute');
                        setAudioOn(true);
                    }
                  }}
                />
                </div>
            </div>
            <PillarScrollers isMobile={isMobileUI(1080)} enableScrollGA={props.enableScrollGA} />
        </>
    );
}

export default Masthead;
